import React from 'react';

const TableSkeleton = ({ 
    rows = 5, 
    columns = 1, 
    showHeader = true, 
    className = "",
    headerLabels = [],
    showCheckbox = false,
    showActions = false
}) => {
    // Calculate total columns including optional ones
    const totalColumns = columns + (showCheckbox ? 1 : 0) + (showActions ? 1 : 0);

    // Generate random widths between 45-80% for each row
    const generateRandomWidths = () => {
        return Array.from({ length: rows }, () => {
            const min = 45;
            const max = 80;
            return Math.floor(Math.random() * (max - min + 1)) + min + '%';
        });
    };

    // Generate random widths for this instance
    const contentWidths = generateRandomWidths();

    const shimmerStyle = {
        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 2.5s infinite',
        borderRadius: '4px'
    };

    const headerShimmerStyle = {
        background: 'linear-gradient(90deg, #689fbd 25%, #c0c0c0 50%, #689fbd 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 2.5s infinite',
        borderRadius: '4px'
    };

    return (
        <div className={`${className}`}>
            {/* Loading indicator */}
            <div className="text-center py-3 text-muted">
                <div className="spinner-border spinner-border-sm me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <span>Loading data...</span>
            </div>
            
            {/* Single skeleton table */}
            <div className="table-responsive">
                <table className="table table-sm table-hover">
                    {showHeader && (
                        <thead style={{boxShadow: 'none'}}>
                            <tr>
                                {showCheckbox && (
                                    <th style={{width: '48px'}} className="px-3 py-2">
                                        <div style={{
                                            ...headerShimmerStyle,
                                            width: '16px',
                                            height: '16px'
                                        }}></div>
                                    </th>
                                )}
                                
                                {Array.from({ length: columns }, (_, colIndex) => (
                                    <th key={`header-${colIndex}`} className="px-3 py-2 text-start">
                                        <div style={{
                                            ...headerShimmerStyle,
                                            height: '18px',
                                            width: '80%'
                                        }}></div>
                                    </th>
                                ))}
                                
                                {showActions && (
                                    <th style={{width: '96px'}} className="px-3 py-2 text-center">
                                        <div style={{
                                            ...headerShimmerStyle,
                                            height: '18px',
                                            width: '60px',
                                            margin: '0 auto'
                                        }}></div>
                                    </th>
                                )}
                            </tr>
                        </thead>
                    )}
                    
                    <tbody>
                        {Array.from({ length: rows }, (_, rowIndex) => (
                            <tr key={`row-${rowIndex}`}>
                                {showCheckbox && (
                                    <td className="px-3 py-2">
                                        <div style={{
                                            ...shimmerStyle,
                                            width: '16px',
                                            height: '16px'
                                        }}></div>
                                    </td>
                                )}
                                
                                {Array.from({ length: columns }, (_, colIndex) => (
                                    <td key={`cell-${rowIndex}-${colIndex}`} className="px-3 py-2">
                                        <div style={{
                                            ...shimmerStyle,
                                            height: '14px',
                                            width: contentWidths[rowIndex]
                                        }}></div>
                                    </td>
                                ))}
                                
                                {showActions && (
                                    <td className="px-3 py-2">
                                        <div className="d-flex gap-2">
                                            <div style={{
                                                ...shimmerStyle,
                                                width: '28px',
                                                height: '28px'
                                            }}></div>
                                            <div style={{
                                                ...shimmerStyle,
                                                width: '28px',
                                                height: '28px'
                                            }}></div>
                                        </div>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
            {/* Shimmer animation CSS */}
            <style>{`
                @keyframes shimmer {
                    0% {
                        background-position: -200% 0;
                    }
                    100% {
                        background-position: 200% 0;
                    }
                }
            `}</style>
        </div>
    );
};

export default TableSkeleton;